import React, { Component } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { Col, Row, Button, UncontrolledTooltip } from 'reactstrap';
import { getAPI, postAPI } from '../Base/API';
import { handleNotification } from "../Base/Common/Notification";
import { StyledCard, StatusBadge, PaymentGatewayLogo } from '../Base/Common/CommonUIComponents';
import { getRightVoucherId, getValidPaymentMethods, PAYMENT_GATEWAYS, PAYMENT_STATUS } from '../Base/Common/ReferenceDataFunctions';
import { FormattedMessage } from 'react-intl';
import BlockUi from 'react-block-ui';
import Authorization from '../Base/Authorization';
import { RegistSaleOnPmsModal } from './RegistSaleOnPmsModal';
import OnlinePaymentModal from './OnlinePaymentModal';
import RefundModal from './RefundModal';

export class OnlineSalesDetail extends Component {
    static displayName = OnlineSalesDetail.name;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleRegistSaleOnPmsModal = this.toggleRegistSaleOnPmsModal.bind(this);
        this.form = React.createRef();
        this.state = {
            block: true,
            modal: false,
            onlinePaymentModal: false,
            onlinePayment: {},
            registSaleOnPmsModal: false
        }
    }

    componentDidMount() {
        if (this.props.match.params.id)
            this.getOnlinePaymentsDetails(this.props.match.params.id)

    }

    getOnlinePaymentsDetails = (id) => {
        this.setState({ block: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {

                this.setState({ onlinePayment: data.response.length > 0 ? data.response[0] : [],  block: false });
            }
        }, '/api/Voucher/Voucher/v1/onlineSale/' + id);
    }

    checkPaymentUpdates() {
        this.setState({ block: true });

        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="OnlineSalesDetail.SyncPaymentSuccessfully" />, <FormattedMessage id="OnlineSalesDetail.Success" />);
                    this.setState({ onlinePayment: data.response[0] });
                }
            }
            this.setState({ error: errorMessage, block: false });
        }, '/api/Voucher/Payment/v1/ReconcilePayment/' + this.props.match.params.id);
    }

    toggleModal(modal) {
        this.setState(prevState => ({
            [modal]: !prevState[modal]
        }));
    }

    voucherDetail(id) { this.props.history.push('/VoucherOperationDetails/' + id)}

    refund(e, id) {
        this.setState({ modal: true, selectedVoucher: this.state.onlinePayment.vouchers.find(el => el.id === id) })

    }

    updateFilterCombo(val, evt) {
        
        if (evt) {
            let name = evt.name;
            let value = val ? val.value : val;

            this.setState({ [name]: value });
        }
    }

    sendNotification() {
        this.setState({ block: true });
        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                else if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="OnlineSalesDetail.NotificationSentSuccessfully" />, <FormattedMessage id="OnlineSalesDetail.Success" />);

                    this.setState({ block: false }, () => this.getOnlinePaymentsDetails(this.props.match.params.id));
                }
            }
            else this.setState({ block: false });
        }, '/api/Voucher/v1/Notification/sendOnlineSaleNotification/' + this.state.onlinePayment.id);

    }

    toggleRegistSaleOnPmsModal() {
        this.setState(prevState => ({
            registSaleOnPmsModal: !prevState.registSaleOnPmsModal
        }))
    }

    updateOnlinePayment = (name, email) => {
        this.setState({
            onlinePayment: {
                ...this.state.onlinePayment,
                name, 
                email
            }
        })
    }


    render() {
        const { onlinePayment, registSaleOnPmsModal, onlinePaymentModal } = this.state;

        const isRegisterOnPmsDisabled = this.state.onlinePayment.vouchers && this.state.onlinePayment.vouchers.length > 0 && this.state.onlinePayment.vouchers.find(v => v.invoiceReference !== null && v.pmsInvoiceURL);
        
        const help = <div> </div>
        return (

            <>
                {this.state.modal ?
                    <RefundModal
                        modal={this.state.modal}
                        toggle={() => this.toggleModal('modal')}
                        selectedVoucher={this.state.selectedVoucher}
                        refreshData={() => this.getOnlinePaymentsDetails(this.props.match.params.id)}
                        paymentGateway={onlinePayment.paymentGateway}
                    />
                : ''}
                {
                    registSaleOnPmsModal ?
                        <RegistSaleOnPmsModal isOpen={registSaleOnPmsModal} toggle={this.toggleRegistSaleOnPmsModal} vouchers={this.state.onlinePayment.vouchers} name={this.state.onlinePayment.name} email={this.state.onlinePayment.email} />
                        : 
                        <div/>
                }

                {onlinePaymentModal ?
                    <OnlinePaymentModal
                        isOpen={onlinePaymentModal}
                        toggle={() => this.toggleModal('onlinePaymentModal')}
                        updateOnlinePayment={this.updateOnlinePayment}
                        onlinePaymentId={onlinePayment.id}
                        name={onlinePayment.name}
                        email={onlinePayment.email}
                    />
                : ''}

                <BlockUi tag="div" blocking={this.state.block}>
                <Row className="mb-1">
                        <Col className="text-right d-flex justify-content-end">
                            
                            <Button className="btn-sm btn-host mr-1" id="viewReceiptTooltip" disabled={this.state.onlinePayment.receiptUrl == undefined} onClick={() => window.open(this.state.onlinePayment.receiptUrl, "_blank")} ><i className="fa-solid fa-receipt" ></i> </Button>
                            <UncontrolledTooltip placement="bottom" target="viewReceiptTooltip">
                                <FormattedMessage id="OnlineSalesDetail.ViewReceipt" />
                            </UncontrolledTooltip>
                            <Authorization
                                perform="onlineSales:send"
                                yes={() => (
                                    <div>
                                        <Button className="btn-sm btn-host mr-1" id="emailTooltip" onClick={this.sendNotification.bind(this)}  ><i className="fa-regular fa-envelope"></i> </Button>
                                        <UncontrolledTooltip placement="bottom" target="emailTooltip">
                                            <FormattedMessage id="OnlineSalesDetail.SendVoucher" />
                                        </UncontrolledTooltip>
                                    </div>
                                )}
                                no={() => <div></div>}
                            />
                            {onlinePayment.channelConfigId !== 2 && this.state.onlinePayment.paymentStatus !== PAYMENT_STATUS.SUCCEEDED ?
                                <span>
                                    <Button className="btn-sm btn-host mr-1" id="paymentStatusTooltip" onClick={this.checkPaymentUpdates.bind(this)}><i class="fa-regular fa-square-check"></i></Button>
                                    <UncontrolledTooltip placement="bottom" target="paymentStatusTooltip">
                                        <FormattedMessage id="OnlineSalesDetail.SyncPaymentStatus" />
                                    </UncontrolledTooltip>
                                </span>
                            : ''}
                            <Authorization
                                perform="voucher:registOnPms"
                                yes={() => (
                                    <div>
                                        <Button className="btn-sm btn-host" id="registOnPmsTooltip" onClick={this.toggleRegistSaleOnPmsModal} disabled={isRegisterOnPmsDisabled}>
                                            <i class="fa-regular fa-share-from-square" />
                                        </Button>
                                        <UncontrolledTooltip placement="bottom" target="registOnPmsTooltip">
                                            <FormattedMessage id="OnlineSalesDetail.RegistOnPms" />
                                        </UncontrolledTooltip>
                                    </div>
                                )}
                                no={() => <div></div>}
                            />
                    </Col>
                    </Row>
                </BlockUi>

                <StyledCard icon={'fa-solid fa-gift'} title={'OnlineSalesDetail.OnlineSale'} help={help} error={this.state.error} block={this.state.block}>
                    <Row className="mb-2 align-items-center">
                        {onlinePayment.paymentGateway ?
                            <>
                                <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.Gateway" /></Col>
                                <Col><PaymentGatewayLogo gateway={onlinePayment.paymentGateway} /></Col>
                            </>
                        : ''}
                        <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.PaymentStatus" /></Col>
                        <Col className="d-flex align-items-center justify-content-between">
                            <StatusBadge kind="payment" status={onlinePayment.paymentStatus} />
                            <Button className="btn-sm btn-host" onClick={() => this.toggleModal('onlinePaymentModal')} >
                                <i className="fa-solid fa-pen-to-square" />
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.CreateDate" /></Col>
                        <Col> {this.state.onlinePayment.createdAt}</Col>
                        <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.SaleDate" /></Col>
                        <Col> {this.state.onlinePayment.createdAt}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.Name" /></Col>
                        <Col> {this.state.onlinePayment.name}</Col>
                        <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.Email" /> </Col>
                        <Col> {this.state.onlinePayment.email}</Col>
                    </Row>
                    {
                        onlinePayment.channelConfigId !== 2 ?
                            <Row className="mb-2">
                                <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.SessionId" /></Col>
                                <Col className="text-break">{this.state.onlinePayment.sessionId}</Col>
                                <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.PaymentIntentId" /></Col>
                                <Col className="text-break">{this.state.onlinePayment.paymentIntentId}</Col>
                            </Row>
                            :
                            <div />
                    }
                    {onlinePayment.from && onlinePayment.to ?
                        <div>
                            <Row className="mt-4">
                                <Col>
                                    <h6><FormattedMessage id="VoucherOperationDetails.GiftInfo" /></h6>
                                </Col>
                            </Row>
                            <hr className="my-1 mb-2" />
                            <Row className="mb-2">
                                <Col className="col-2"><FormattedMessage id="VoucherManagement.From" /></Col>
                                <Col> {onlinePayment.from}</Col>
                                <Col className="col-2"><FormattedMessage id="VoucherManagement.To" /></Col>
                                <Col> {onlinePayment.to}</Col>
                            </Row>

                            <Row className="mb-2">
                                <Col className="col-2"><FormattedMessage id="VoucherManagement.Sender" /></Col>
                                <Col> {onlinePayment.sender}</Col>
                                <Col className="col-2"><FormattedMessage id="VoucherManagement.Recipient" /></Col>
                                <Col> {onlinePayment.recipient}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2"><FormattedMessage id="VoucherManagement.Message" /></Col>
                                <Col> {onlinePayment.message}</Col>
                            </Row>
                        </div>
                        : ''}
                </StyledCard >
                {onlinePayment.paymentGateway ?
                    <>
                        <div className="mb-2" />
                        <StyledCard icon={'fa-solid fa-gears'} title={'OnlineSalesDetail.TechnicalDetails'} block={this.state.block}>
                            <Row className="mb-2">
                                <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.PaymentErrorCode" /></Col>
                                <Col>{onlinePayment.paymentErrorCode || '-'}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.GatewayStatus" /></Col>
                                <Col>{onlinePayment.gatewayStatus || '-'}</Col>
                                <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.GatewayErrorCode" /></Col>
                                <Col>{onlinePayment.gatewayErrorCode || '-'}</Col>
                            </Row>
                            {onlinePayment.paymentGateway === PAYMENT_GATEWAYS.REDUNIQ ?
                                <Row className="mb-2">
                                    <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.PaymentMethod" /></Col>
                                    <Col>{getValidPaymentMethods(PAYMENT_GATEWAYS.REDUNIQ).find(m => m.value === onlinePayment.mode)?.label || onlinePayment.mode || '-'}</Col>
                                </Row>
                            : ''}
                            {onlinePayment.mbReference ?
                                <Row className="mb-2">
                                    <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.MbReference" /></Col>
                                    <Col>{onlinePayment.mbEntity} / {onlinePayment.mbReference}</Col>
                                    <Col className="col-2"><FormattedMessage id="OnlineSalesDetail.MbExpiresAt" /></Col>
                                    <Col>{onlinePayment.mbExpiresAt ? onlinePayment.mbExpiresAt.replace('T', ' ').substring(0, 16) : '-'}</Col>
                                </Row>
                            : ''}
                        </StyledCard>
                    </>
                : ''}
                <div className="mb-2" />
                <StyledCard icon={'fa-solid fa-cart-shopping'} title={'OnlineSalesDetail.ShoppingCard'} help={help} block={this.state.block}>
                    <Row className="mb-2">
                        <Col><FormattedMessage id="OnlineSalesDetail.VoucherCode" /></Col>
                        <Col><FormattedMessage id="OnlineSalesDetail.Quantity" /></Col>
                        <Col><FormattedMessage id="OnlineSalesDetail.PayedAmount" /></Col>
                    </Row>
                {this.state.onlinePayment.items && this.state.onlinePayment.items.map((el, k) =>
                    <Row key={k} className="mb-2">
                        <Col>{el.voucherTypeCode}</Col>
                        <Col>{el.quantity}</Col>
                        <Col>{el.payedAmount}</Col>
                    </Row>
                    
                )}
                </StyledCard >
                <div className="mb-2"/>
                <StyledCard icon={'fa-solid fa-ticket'} title={'OnlineSalesDetail.EmitedVouchers'} help={help} block={this.state.block}>
                    <Row className="mb-2 ">
                        <Col className="col-3"><FormattedMessage id="OnlineSalesDetail.VoucherId" /></Col>
                        <Col><FormattedMessage id="OnlineSalesDetail.Status" /></Col>
                        <Col><FormattedMessage id="OnlineSalesDetail.ValidUntil" /></Col>
                        <Col sm={1}><FormattedMessage id="OperationManagement.Number" /></Col>
                        <Col><FormattedMessage id="OnlineSalesDetail.Code" /></Col>
                        {global.modules?.some(m => m === "VoucherRFID") ?
                            <Col><FormattedMessage id="VoucherOperationDetails.RfId" /></Col>
                        : ''}
                        {onlinePayment.channelConfigId !== 2 ?
                            <Col sm={1}>
                            </Col>
                        :'' }
                    </Row>
                    {
                        this.state.onlinePayment.vouchers && this.state.onlinePayment.vouchers.map((el, k) =>
                            <Row key={k} className="py-1 overbglight align-items-center">
                                <Col className="col-3">
                                    <a onClick={this.voucherDetail.bind(this, el.id)} style={{ cursor: "pointer", color: "blue" }}>{getRightVoucherId(el.voucherId, el.voucherIdFirst8)} </a>
                                </Col>
                                <Col>
                                    <StatusBadge kind="voucher" status={el.status} />
                                </Col>
                                <Col>
                                    {el.validUntil}
                                </Col>
                                <Col sm={1}>
                                    {el.ordinal}
                                </Col>
                                <Col>
                                    {el.voucherTypeCode}
                                </Col>                                
                                {global.modules?.some(m => m === "VoucherRFID") ?
                                    <Col>
                                        {el.rfId}
                                    </Col>
                                : ''}
                                { onlinePayment.channelConfigId !== 2 ?
                                        <Col className="text-right col-1">
                                            <Authorization
                                                perform="onlineSales:refund"
                                                yes={() => (
                                                    <div>
                                                        <Button className="btn-sm btn-host mb-1" disabled={el.status == 'refunded' || onlinePayment.paymentStatus !== PAYMENT_STATUS.SUCCEEDED} id={"RefundTooltip" + k} onClick={() => this.refund(this, el.id)}><i className="fa-solid fa-rotate-left"></i> </Button>
                                                        <UncontrolledTooltip placement="left" target={"RefundTooltip" + k}>
                                                            <FormattedMessage id="OnlineSalesDetail.RefundPayment" />
                                                        </UncontrolledTooltip>
                                                    </div>
                                                )}
                                                no={() => <div></div>}
                                            />
                                        </Col>
                                        :
                                        <span />
                                }
                            {/*<Col className="col-4">{el.voucherTypeDescription}</Col>*/}
                            </Row>
                        )}
                </StyledCard>
            </>
        );
    }
}
